import { E_QUERY_ITEM_CONDITION, IQuery, IQueryDataType, IQueryItem, IQueryItemField, IQueryValueText } from '@patsnap/synapse_common_interface'
type IFieldQueryItemTransformMap = Record<
  string,
  {
    display2store: (queryItem: IQueryItemField) => IQueryItemField
    store2display: (queryItem: IQueryItemField) => IQueryItemField
  }
>

type IFieldQueryItemsTransform = (queryItems: IQueryItem[]) => IQueryItem[]

export const drugFieldQueryItemTransformMap: IFieldQueryItemTransformMap = {
  DEV_ORG_TYPE_ONEID: {
    display2store(queryItem: IQueryItemField) {
      const fieldValue = queryItem.value as IQueryValueText[]
      const otherValue = fieldValue.find((item) => item.value === 'Other')
      if (!otherValue) {
        return queryItem
      }
      const newFieldValue = fieldValue
        .filter((item) => item.value !== 'Other')
        .concat([
          {
            type: 'text',
            display_name_cn: '政府',
            display_name_en: 'Government',
            value: 'Government',
          },
          {
            type: 'text',
            display_name_cn: '非营利组织',
            display_name_en: 'Nonprofit',
            value: 'Nonprofit',
          },
        ])
      return {
        ...queryItem,
        value: newFieldValue,
      }
    },
    store2display(queryItem: IQueryItemField) {
      const fieldValue = queryItem.value as IQueryValueText[]
      const otherValues = fieldValue.filter((item) => ['Government', 'Nonprofit'].includes(item.value))
      if (!otherValues.length) {
        return queryItem
      }
      const newFieldValue = fieldValue
        .filter((item) => !['Government', 'Nonprofit'].includes(item.value))
        .concat([
          {
            type: 'text',
            display_name_cn: '其他',
            display_name_en: 'Other',
            value: 'Other',
          },
        ])
      return {
        ...queryItem,
        value: newFieldValue,
      }
    },
  },
}

export const clinicalQueryItemTransformMap: IFieldQueryItemTransformMap = {
  VIRTUAL_SPONSOR_TYPE: {
    display2store(queryItem: IQueryItemField) {
      const fieldValue = queryItem.value as IQueryValueText[]
      const otherValue = fieldValue.find((item) => item.value === 'Other')
      if (!otherValue) {
        return queryItem
      }
      const newFieldValue = fieldValue
        .filter((item) => item.value !== 'Other')
        .concat([
          {
            type: 'text',
            display_name_cn: '政府',
            display_name_en: 'Government',
            value: 'Government',
          },
          {
            type: 'text',
            display_name_cn: '非营利组织',
            display_name_en: 'Nonprofit',
            value: 'Nonprofit',
          },
        ])
      return {
        ...queryItem,
        value: newFieldValue,
      }
    },
    store2display(queryItem: IQueryItemField) {
      const fieldValue = queryItem.value as IQueryValueText[]
      const otherValues = fieldValue.filter((item) => ['Government', 'Nonprofit'].includes(item.value))
      if (!otherValues.length) {
        return queryItem
      }
      const newFieldValue = fieldValue
        .filter((item) => !['Government', 'Nonprofit'].includes(item.value))
        .concat([
          {
            type: 'text',
            display_name_cn: '其他',
            display_name_en: 'Other',
            value: 'Other',
          },
        ])
      return {
        ...queryItem,
        value: newFieldValue,
      }
    },
  },
}
export const clinicalTrialResultQueryItemTransformMap: IFieldQueryItemTransformMap = {}

export const patentQueryItemTransformMap: IFieldQueryItemTransformMap = {}

export const paperQueryItemTransformMap: IFieldQueryItemTransformMap = {}

export const drugDealQueryItemTransformMap: IFieldQueryItemTransformMap = {}

export const transMedicineQueryItemTransformMap: IFieldQueryItemTransformMap = {}

// format 单个 queryItem
export const queryDataTypeQueryItemTransformMap: Partial<Record<IQueryDataType, IFieldQueryItemTransformMap>> = {
  drug: drugFieldQueryItemTransformMap,
  clinical_trial: clinicalQueryItemTransformMap,
  patent: patentQueryItemTransformMap,
  paper: paperQueryItemTransformMap,
  clinical_trial_result: clinicalTrialResultQueryItemTransformMap,
  drug_deal: drugDealQueryItemTransformMap,
  translational_medicine: transMedicineQueryItemTransformMap,
}

export const drugFieldQueryItemsTransformMap: IFieldQueryItemsTransform = (queryItems) => {
  const milestonePhaseIndex = queryItems.findIndex((item) => 'fields' in item && (item.fields || []).includes('MILESTONE_ID'))
  const milestoneDateIndex = queryItems.findIndex((item) => 'fields' in item && (item.fields || []).includes('MILESTONE_DATE'))

  if (milestonePhaseIndex > -1 && milestoneDateIndex > -1) {
    const milestonePhaseQueryItem = queryItems[milestonePhaseIndex] as IQueryItemField
    const milestoneDateQueryItem = queryItems[milestoneDateIndex] as IQueryItemField

    const milestoneQuery: IQuery = {
      type: 'group',
      any: [],
    }

    milestonePhaseQueryItem.value.forEach((milestonePhase) => {
      const milestonePhaseFields = [(milestonePhase as IQueryValueText).value]
      milestoneQuery.any?.push({
        type: 'field',
        fields: milestonePhaseFields,
        condition: E_QUERY_ITEM_CONDITION.ANY,
        value: milestoneDateQueryItem.value,
      })
    })

    // 替换原来的 milestone 检索项
    queryItems.splice(milestonePhaseIndex, 1, milestoneQuery)
    // 删除 milestone 日期字段
    queryItems.splice(milestoneDateIndex, 1)
  }
  return queryItems
}

// format 待提交的 QueryItems
export const queryDataTypeQueryItemsTransformMap: Partial<Record<IQueryDataType, IFieldQueryItemsTransform>> = {
  // 目前用于药物里程碑和日期检索项合并
  drug: drugFieldQueryItemsTransformMap,
}
